import React from 'react';
import { steps } from '../data/site';
import { BookingButton } from './BookingButton';
export function WorkingTogether() {
  return <section id="working-together" className="bg-sage border-y border-sage-line" data-id="element-116" data-mp="reks2zwo6nx0">
      <div className="max-w-content mx-auto px-5 sm:px-6 lg:px-10 py-20 md:py-24" data-id="element-117" data-mp="wc44du9t4qmb">
        <div className="max-w-2xl" data-id="element-118" data-mp="11cifjl6pggok">
          <p className="text-xs sm:text-[0.8125rem] uppercase tracking-[0.14em] font-medium text-forest" data-id="element-119" data-mp="11djs5u3ddb8e">
            Working together
          </p>
          <h2 className="mt-4 font-serif text-3xl md:text-[2.5rem] leading-tight tracking-tight text-ink" data-id="element-120" data-mp="1aceyd66eylbp">
            A clear place to start.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-121" data-mp="1f4f1f7hs5uci">
            We begin by understanding what needs to change and whether I’m the right person to
            help.
          </p>
        </div>

        <ol className="mt-12 grid md:grid-cols-3 gap-5 lg:gap-6" data-id="element-122" data-mp="1p000awrjyei1">
          {steps.map(step => <li key={step.number} className="flex flex-col h-full bg-paper-raised border border-sage-line rounded-lg p-6 md:p-7" data-id="element-123" data-mp="1t121hj5150mn">
              <p className="text-xs uppercase tracking-[0.14em] font-medium text-forest" data-id="element-124" data-mp="gb95g4rw32n6">
                {step.number} / {step.verb}
              </p>
              <h3 className="mt-4 font-serif text-xl md:text-[1.375rem] leading-snug text-ink" data-id="element-125" data-mp="6ewdpcfwmyv2">
                {step.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-ink-soft" data-id="element-126" data-mp="141vd3uxzekwn">{step.body}</p>
              <p className="mt-auto pt-6" data-id="element-127" data-mp="z4mpvfxz7qoj">
                <span className="block pt-4 border-t border-rule text-sm font-medium text-ink" data-id="element-128" data-mp="z5o5zytun3d4">
                  {step.detail}
                </span>
              </p>
            </li>)}
        </ol>

        <div className="mt-8 bg-paper-raised border border-sage-line rounded-lg p-6 md:p-7 flex flex-col md:flex-row md:items-center md:justify-between gap-5 md:gap-10" data-id="element-129" data-mp="1mswawfnd8aem">
          <div className="max-w-xl" data-id="element-130" data-mp="1i033tl4fcpzd">
            <h3 className="font-serif text-xl leading-snug text-ink" data-id="element-131" data-mp="3c9i0e8zy5sts">
              Looking for individual leadership support?
            </h3>
            <p className="mt-2 text-base leading-relaxed text-ink-soft" data-id="element-132" data-mp="3h8l8617bad5g">
              Business and executive coaching for leaders navigating decisions, challenges, and
              transitions.
            </p>
          </div>
          <BookingButton location="coaching" variant="link" className="self-start md:self-auto shrink-0 text-left" data-id="element-133" data-mp="37gymtc19exoz" />
        </div>
      </div>
    </section>;
}